var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSimulationStart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 69.995 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Start simulation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-play",
    "data-name": "Icon awesome-play",
    d: "M66.31,33.543l-55-32.514C6.843-1.612,0,.95,0,7.481V72.494a7.493,7.493,0,0,0,11.312,6.453l55-32.5a7.492,7.492,0,0,0,0-12.906Z",
    transform: "translate(0 -0.002)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimulationStart);
export default __webpack_public_path__ + "static/media/simulationStart.a238e99fbd8ceec524b77a9c379fa524.svg";
export { ForwardRef as ReactComponent };